import { render } from "./App.vue?vue&type=template&id=af4af362&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/css/app.css?vue&type=style&index=0&id=af4af362&scoped=true&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4af362"]])

export default __exports__